import { InfoTooltip, Translation } from '@ps/web-shared-components';
import React from 'react';
import { useField } from 'react-final-form';

import { PEPHIOOptions } from '../../PEPHIOSelection/PEPHIOSelection';

import {
  TXTWCL_If_your_exact_job_title_is_not_ELL,
  TXTWCL_Occupation,
  TXTWCL_Please_enter_your_job_title_Xe_ELL,
  TXTWCL_Position_Title
} from './OccupationInfo.messages.json';
import styles from './OccupationInfo.scss';

const OccupationInfo = () => {
  const {
    input: { value: pepHioSelection }
  } = useField('pepHioSelection');

  return (
    <div className={styles.tooltipWrapper}>
      {pepHioSelection === PEPHIOOptions.PEPOrHIO ? (
        <Translation {...TXTWCL_Position_Title} />
      ) : (
        <Translation {...TXTWCL_Occupation} />
      )}
      <InfoTooltip
        tagName="span"
        iconClassName={styles.infoTooltip}
        content={[
          { ...TXTWCL_Please_enter_your_job_title_Xe_ELL },
          { ...TXTWCL_If_your_exact_job_title_is_not_ELL }
        ]}
      />
    </div>
  );
};

export default OccupationInfo;
